import ContactFbIcon from 'components/lib/icons/contact_fb_icon';
import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import FbUserProfileModel from 'models/customer_profile/fb_user_profile';

const FbUserProfile = ({ className, profile }) => {
  let profileName = profile ? profile.getName() : undefined;

  return (
    <div className={classnames('fbUserProfile', className)}>
      <ContactFbIcon className="customerProfile-fbIcon" />
      <div className="fbUserProfile-name">{profileName || 'Private User'}</div>
    </div>
  );
};

FbUserProfile.propTypes = {
  className: PropTypes.string,
  profile: PropTypes.instanceOf(FbUserProfileModel),
};

export default FbUserProfile;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/profile/__specs__/fb_user_profile.jsx